var map = {
	"./de": 77853,
	"./de.js": 77853,
	"./es": 97650,
	"./es.js": 97650,
	"./fr": 85498,
	"./fr.js": 85498,
	"./it": 88383,
	"./it.js": 88383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51692;